import { createStoreForProduct } from './ProductStore'

export const AvalancheForecastStore = createStoreForProduct('avalancheforecast')
